import { Ident } from '@mode-switch/express';
import { Adapter } from '../Adapter';
import { Compiler } from '../Compiler';
import { Pipeline } from '../Pipeline';
import { GenericCatalog } from './Catalog';
export class GenericAdapter {
    alias() {
        return Ident.next('F');
    }
    construct(model, viewName, attr, opts = {}) {
        const dimension = (orig) => {
            switch (orig.formula.type.name) {
                case "TIMESTAMP": {
                    const source = `DATETRUNC('DAY', [${orig.name}])`;
                    return Adapter.Fields.make(this, model, viewName, source, orig.type, opts);
                }
                default: {
                    const source = `[${orig.name}]`;
                    return Adapter.Fields.make(this, model, viewName, source, orig.type, opts);
                }
            }
        };
        const measure = (orig) => {
            const source = `${orig.defaults.aggregate}([${orig.name}])`;
            return Adapter.Fields.make(this, model, viewName, source, orig.type, opts);
        };
        switch (attr.source) {
            case "NAMES":
                return Adapter.Fields.names(this, opts.alias);
            case "VALUES":
                return Adapter.Fields.values(this, opts.alias);
            case "CALC":
            case "COLUMN":
                switch (attr.scale) {
                    case "CATEGORICAL":
                        return dimension(attr);
                    case "ORDINAL":
                        switch (attr.role) {
                            case "DIMENSION":
                                return dimension(attr);
                            case "MEASURE":
                                return measure(attr);
                        }
                    case "QUANTITATIVE":
                        return measure(attr);
                }
            default:
                return attr;
        }
    }
    catalog() {
        return new GenericCatalog();
    }
    compile(model, viewName, source, exprEnv) {
        const catalog = this.catalog();
        const pipeline = Pipeline.make();
        return Compiler.compile(catalog, pipeline, model, viewName, source, exprEnv);
    }
}
